// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"4a5d3dd8","952":"cb462a93"}[chunkId] + ".chunk.js";
};